import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {CircularProgress} from "@material-ui/core";


const Slideshow = ({images, currentIndex, timeout, startDelay, onChange, paused, loading, defaultImage, ...props}) => {

    const [index, setIndex] = useState(currentIndex);
    const [timeoutId, setTimeoutId] = useState(0);
    const defaultImg = <img alt={'default'} src={defaultImage} {...props}/>;

    useEffect(() => {
        if (currentIndex < images.length) {
            setIndex(currentIndex);
        }
        // eslint-disable-next-line
    }, [currentIndex]);

    const changeToNextSlideHandler = (delay = timeout) => {
        clearTimeout(timeoutId);
        const id = setTimeout(() => {
            setIndex(prevIdx => {
                let nextIdx = prevIdx + 1;
                if (nextIdx >= images.length) {
                    nextIdx = 0;
                }
                setIndex(nextIdx);
                onChange(nextIdx, images.hasOwnProperty(nextIdx) ? images[nextIdx] : null);
                return nextIdx;
            });
            changeToNextSlideHandler();
        }, delay);
        setTimeoutId(id);
        return id;
    };

    useEffect(() => {
        setIndex(0);
        changeToNextSlideHandler(startDelay + timeout);
        // eslint-disable-next-line
    }, [images]);

    useEffect(() => {
        return () => clearTimeout(timeoutId);
    }, [timeoutId]);

    if (!images.length) return defaultImg;

    if (loading) return (
        <div {...props}>
            <CircularProgress/>
        </div>
    );

    const img = images[index];

    if (!img) return defaultImg;

    return (
        <img alt={img.image.alt} src={img.image.src} {...props}/>
    );
};

Slideshow.propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        position: PropTypes.string,
        slideshow: PropTypes.string,
        image: PropTypes.shape({
            id: PropTypes.string,
            src: PropTypes.string,
            title: PropTypes.string,
            alt: PropTypes.string,
            width: PropTypes.string,
            height: PropTypes.string,
        }),
        tags: PropTypes.arrayOf(PropTypes.string),
    })),
    timeout: PropTypes.number,
    startDelay: PropTypes.number,
    onChange: PropTypes.func,
    currentIndex: PropTypes.number,
    paused: PropTypes.bool,
    loading: PropTypes.bool,
    defaultImage: PropTypes.string,
};

Slideshow.defaultProps = {
    images: [],
    timeout: 5000,
    startDelay: 0,
    onChange: () => null,
    currentIndex: 0,
    paused: false,
    loading: false,
    defaultImage: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
};

export default Slideshow;
